import { ScrollReveal } from '@/components/effects/ScrollReveal';
import { ShieldCheck, Layers, Users, MapPin } from 'lucide-react';

const trustItems = [
  { icon: Layers, label: 'Four Specialist Services', desc: 'Defend · Learn · Launch · Reach' },
  { icon: Users, label: 'Practitioner-Led', desc: 'Real experts across every service' },
  { icon: ShieldCheck, label: 'ICO Registered', desc: 'UK GDPR compliant practice' },
  { icon: MapPin, label: 'London Specialist', desc: 'Face to face or online' },
];

export const TrustBar = () => {
  return (
    <section
      data-testid="trust-bar"
      className="py-10 sm:py-14"
      style={{ background: 'var(--bg)' }}
    >
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <ScrollReveal>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
            {trustItems.map((item) => {
              const Icon = item.icon;
              return (
                <div
                  key={item.label}
                  data-testid={`trust-item-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="flex items-center gap-3 px-4 py-3 rounded-lg transition-transform duration-200 cursor-default group"
                  style={{
                    background: 'rgba(255,255,255,0.03)',
                    border: '1px solid rgba(255,255,255,0.06)',
                  }}
                >
                  <Icon
                    size={18}
                    className="transition-transform duration-200 group-hover:scale-[1.18]"
                    style={{ color: 'var(--a)', flexShrink: 0 }}
                  />
                  <div>
                    <p className="font-body text-sm font-medium" style={{ color: 'var(--white)' }}>{item.label}</p>
                    <p className="font-body text-xs" style={{ color: 'var(--ts)' }}>{item.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
